import useIsDesktop from "hooks/useIsDesktop";
import DatePicker from ".";
import DatePickerDesktop from "./Desktop";
import wrapperHOC from "@Utils/wrapperHOC";

const DatePickerWrapper = (props: any) => {
  const { isAboveMD = true } = props;
  const isDesktop = useIsDesktop() && isAboveMD;

  if (isDesktop) {
    return <DatePickerDesktop {...props} />;
  }

  return <DatePicker {...props} />;
};

export default wrapperHOC(DatePickerWrapper, {
  componentName: "DatePickerWrapper-DatePicker-Global",
  showForChina: true,
});
